/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export type FilterOperation =
  'EQUALS_OPERATOR' | 
  'GT_OPERATOR' | 
  'GTE_OPERATOR' | 
  'LT_OPERATOR' | 
  'LTE_OPERATOR' | 
  'CONTAINS_OPERATOR' | 
  'EQUALS_STRING_OPERATOR' | 
  'STARTS_WITH_STRING_OPERATOR' | 
  'ENDS_WITH_STRING_OPERATOR'


export function FilterOperationFromJSON(json: any): FilterOperation {
    return FilterOperationFromJSONTyped(json, false);
}

export function FilterOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterOperation {
    return json as FilterOperation;
}

export function FilterOperationToJSON(value?: FilterOperation | null): any {
    return value as any;
}

